import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import './accolades-carousel.component.scss';
var AccoladesCarousel = /** @class */ (function (_super) {
    tslib_1.__extends(AccoladesCarousel, _super);
    function AccoladesCarousel(element) {
        return _super.call(this, element) || this;
    }
    AccoladesCarousel.prototype.init = function () {
        this.sliderItems = Number(this.element.getAttribute('data-items'));
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.windowWidth = document.documentElement.clientWidth;
        if (this.sliderItems) {
            switch (this.sliderItems) {
                case 1:
                    this.breakpoints = {};
                    break;
                default:
                    this.breakpoints = {
                        1600: {
                            initialSlide: 0,
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        1200: {
                            initialSlide: 0,
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        992: {
                            initialSlide: 0,
                            slidesPerView: 1.3,
                            spaceBetween: 20,
                        },
                        576: {
                            initialSlide: 0,
                            slidesPerView: 1.3,
                            spaceBetween: 15,
                        }
                    };
                    break;
            }
        }
        else {
            this.breakpoints = {
                1600: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                992: {
                    initialSlide: 0,
                    slidesPerView: 1.3,
                    spaceBetween: 20,
                },
                576: {
                    initialSlide: 0,
                    slidesPerView: 1.3,
                    spaceBetween: 15,
                }
            };
        }
        this.sliderConfig = {
            slidesPerView: this.sliderItems,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: this.breakpoints,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    AccoladesCarousel.prototype.bindEvents = function () { };
    return AccoladesCarousel;
}(Base));
export { AccoladesCarousel };



//////////////////
// WEBPACK FOOTER
// ./components/accolades-carousel/accolades-carousel.component.ts
// module id = 38
// module chunks = 0